import { ActionProps } from "../../ts";
import { LIST_OF_DASHBOARD, LIST_OF_DASHBOARD_ERROR } from "../ActionTypes";

const initialState = { info: null };

const dashboardStore = (state: any = initialState, action: ActionProps) => {
  const { type, payload } = action;
  switch (type) {
    case LIST_OF_DASHBOARD: {
      return {
        ...state,
        info: payload,
      };
    }
    case LIST_OF_DASHBOARD_ERROR: {
      return {
        ...state,
        info: null,
      };
    }
    default:
      return state;
  }
};

export default dashboardStore;